import { Box, styled } from '@mui/material'
import { ContainerPositionType } from '@operations/app/api'
import { ColorSchema, CraneIcon, VesselIcon, YardIcon } from '@tom-ui/ui'

interface Props {
  type?: ContainerPositionType
  zoom?: number
  backgroundColorTransparent?: boolean
  color?: ColorSchema
  skipPadding?: boolean
}

const IconContainer = styled(Box)<{ transparent?: string; skippadding?: string }>(
  ({ theme, transparent, skippadding }) => ({
    backgroundColor: transparent ? 'transparent' : theme.palette.grey[200],
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: skippadding ? undefined : '8px',
  }),
)

export const ContainerPositionIcon = ({
  type,
  zoom,
  backgroundColorTransparent,
  color,
  skipPadding,
}: Props) => {
  let icon = <CraneIcon color={color} sx={{ transform: `scale(${(zoom ?? 100) / 100})` }} />
  switch (type) {
    case ContainerPositionType.Berth:
      icon = <YardIcon color={color} sx={{ transform: `scale(${(zoom ?? 100) / 100})` }} />
      break
    case ContainerPositionType.Vessel:
      icon = <VesselIcon color={color} sx={{ transform: `scale(${(zoom ?? 100) / 100})` }} />
      break
  }

  return (
    <IconContainer
      transparent={backgroundColorTransparent ? 'true' : undefined}
      skippadding={skipPadding ? 'true' : undefined}
    >
      {icon}
    </IconContainer>
  )
}
